import React from 'react'

import Spacing from 'components/Common/Spacing/Spacing'
import OfferListFullWidthPanel from 'components/OfferList/OfferListFullWidthPanel'
import PaletteProvider from 'contexts/PaletteProvider'
import { EmptyArray } from 'lib/array/arrayUtils'
import { useCuratedTrips } from 'tripPlanner/hooks/api'
import CuratedTripPromotion from 'tripPlanner/Tripkit/CuratedTrips/TripPromotion/CuratedTripPromotion'
import { BasicTrip } from 'tripPlanner/types/common'

interface Props {
  placeId: string
  placeName?: string
}

function HotelSearchTripPromotion({ placeId, placeName }: Props) {
  const { data: trips = EmptyArray as BasicTrip[] } = useCuratedTrips({
    filters: { lePlaceId: placeId },
    limit: 1,
  })

  const hasTrips = trips.length > 0

  if (!hasTrips) {
    return null
  }

  const trip = trips[0]
  const heading = `Looking for inspiration${
    placeName ? ` for ${placeName}` : ''
  }?`
  const subheading = 'View our Curated Trip!'

  return (
    <PaletteProvider type="inverse">
      <OfferListFullWidthPanel variant="light">
        <Spacing pt={40} pb={40}>
          <CuratedTripPromotion
            heading={heading}
            subheading={subheading}
            trip={trip}
          />
        </Spacing>
      </OfferListFullWidthPanel>
    </PaletteProvider>
  )
}

export default HotelSearchTripPromotion
